import { format, parseISO } from 'date-fns';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

export default function ExperienceList({ items, onClick }) {
    const _handleClick = (event, selectedItem) => {
        event.preventDefault();
        onClick && onClick(selectedItem);
    };

    return (
        <div className="px-4 sm:px-6 lg:px-8">
            <div className="mt-8 flex flex-col">
                <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                        <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                            <table className="min-w-full divide-y divide-gray-300">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th
                                            scope="col"
                                            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                        >
                                            Título
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                        >
                                            Descripción
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                        >
                                            Creación
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                        >
                                            Estado
                                        </th>
                                        <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                            <span className="sr-only">Editar</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200 bg-white">
                                    {items.map((item) => (
                                        <tr key={item.id}>
                                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                {item.experienceName}
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 truncate max-w-xs inline-flex">
                                                <span className="truncate max-w-[75%]">{item.experienceDetail}</span>
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                {format(parseISO(item.creation), 'yyyy-MM-dd H:mm')}
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                <span
                                                    className={classNames(
                                                        'inline-flex rounded-full px-2 text-xs font-semibold leading-5',
                                                        item.status ? 'bg-green-100' : 'bg-red-100',
                                                        item.status ? 'text-green-800' : 'text-red-800'
                                                    )}
                                                >
                                                    {item.status ? 'Activo' : 'Inactivo'}
                                                </span>
                                            </td>
                                            <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                <a
                                                    href="#"
                                                    onClick={(e) => _handleClick(e, item)}
                                                    className="text-dl-primary-900 hover:text-dl-accent"
                                                >
                                                    Editar<span className="sr-only">, {item.experienceName}</span>
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
